import styled, { css } from 'vue-styled-components';

import {
    COLORS,
    BEFORE_AFTER_CONTENT,
    applyHoverAndPress,
    GRAY,
    square,
} from '@/styles/common.styled';
import {
    FLEX_VERTICAL_CENTER_DIV,
    FLEX_COLUMN_DIV,
} from '@styles/common.styled.component';

import TrashIcon from '@svgIcons/trash.svg';

export default {
    name: 'EditBox',
    props: {
        title: {
            type: String,
        },
        isFocus: {
            type: Boolean,
            default: false,
        },
        hasDelete: {
            type: Boolean,
            default: false,
        },
    },
    render() {
        return this.wrapTooltip({
            visible: !this.isFocus,
            title: this.$t('EDITABLE_DASHBOARD.edit_box_block_not_editing'),
            content: (
                <EditBox isFocus={this.isFocus}>
                    <EditBoxTitle>
                        {this.title}
                        {this.hasDelete && (
                            <TrashIcon
                                class="trash-icon"
                                v-view-box
                                onClick={() => this.$emit('delete')}
                                width="16px"
                                height="16px"
                            />
                        )}
                    </EditBoxTitle>
                    <EditBoxComponent>{this.$slots.default}</EditBoxComponent>
                </EditBox>
            ),
        });
    },
};

const EditBox = styled(FLEX_VERTICAL_CENTER_DIV, { isFocus: Boolean })`
    margin-bottom: 12px;
    border-radius: 4px;
    background-color: ${COLORS['gray-10']};
    position: relative;
    width: 100%;

    @media screen and (max-width: 767px) {
        margin: 4px 0;
    }

    @media screen and (max-width: 400px) {
        flex-direction: column;
    }

    ${({ isFocus }) =>
        !isFocus &&
        css`
            &::after {
                ${BEFORE_AFTER_CONTENT};
                background: rgba(8, 10, 13, 0.04);
            }
        `}
`;

const EditBoxTitle = styled(FLEX_COLUMN_DIV)`
    justify-content: space-between;
    height: 100%;
    font-size: 12px;
    color: ${COLORS['gray-100']};
    padding: 16px 18px;
    width: 120px;
    max-width: 120px;
    flex-shrink: 0;
    display: flex;
    align-self: flex-start;
    position: relative;
    word-break: keep-all;
    & .trash-icon {
        padding: 4px;
        cursor: pointer;
        border-radius: 2px;
        ${applyHoverAndPress(GRAY(10), 'background-color')};
        box-sizing: content-box;
    }
`;

const EditBoxComponent = styled(FLEX_VERTICAL_CENTER_DIV)`
    padding: 12px 16px;
    width: 100%;
    min-height: 56px;
    border-left: 1px solid white;
`;
